import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, TextField, Typography } from '@mui/material'
import QRCode from 'qrcode.react'
import React, { useEffect, useState } from 'react'
import { XIcons } from '../common/svg/xicons'
import UPI from '../../assests/UPI.png'
import BHIM from '../../assests/Bhim.png'
import googlePay from '../../assests/googlePay.png'
import paytm from '../../assests/paytm.png'
import phonepe from '../../assests/phonepay.png'
import Lineinput from '../common/lineinput'
import { Item } from '../common/snippets'
import ShareIcon from '@mui/icons-material/Share';
import CloseIcon from '@mui/icons-material/Close';
import LineinputV2 from '../common/lineinputV2'
import * as sx from '../common/stylesInline/report_daily_branch'
import { floatFilter, generateChecksum, isEmpty } from '../common/helper'
import { GetRequest, GetRequestNoHeader, PostRequest } from '../common/api'
import { useDispatch } from 'react-redux'
import { BranchRechargeConfirm, BranchRechargeReject, getDQRDetailsInsertUpdate } from '../../store/booking/booking_action'
import { updateAlertError } from '../../store/common/common_action'
import SuccessAndErrorModal from '../common/SuccessAndErrorModal'
import QRTimer from './QRTimer'
import { companySettingsAtom } from '../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
import { alertAtom } from '../common/jotaiState/globalStateAtoms'
import { urls } from '../common/constants'
import { getCurrentDateTime } from '../common/dateHelpers'
import { useTranslation } from '../../i18n/I18nProvider'

const QRScanner = (props) => {
    const { translations } = useTranslation()
    const cs = translations?.common || {}
    const rh = translations?.recharge || {}
    const dispatch = useDispatch()
    const { QRRechargeDeatils, setQRRechargeDetails, DQRDetails,loginData,handleSaveQR , updateModal, setShowQRScanner,minimumAmount=0} = props
    const [open, setOpen] = useState(false); // State to manage the dialog open/close
    const [mobileNo, setMobileNo] = useState(''); // State to manage the mobile number input
    const {QRData, setQRData, remainingTime, setRemainingTime} = props
    const [isSuccess, setIsSuccess] = useState(false)
    const {disableinput, setDisableInput} = props
    const {initialTimeoutRef, endTimeoutRef, intervalIdRef} = props
    const [showQR, setShowQR] = useState(false)
    const [companySettings] = useAtom(companySettingsAtom)
    const [, setAlert] = useAtom(alertAtom)
    const { RemoveQRTransFeeFromCustAmt = 0, MinQrAmount = 0 } = companySettings
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
   
    // const resetScreen = () => {
    //     // Logic to reset the screen
    //     setTimer(900); // Reset timer to 15 minutes
    //     setIsTimerActive(false);
    //     // dispatch(updateAlertError({ show: true, msg: `Recharge failed!. Please Try again. `, nextId: '' }))
    //     setQRRechargeDetails({rechargeAmt:0, processingFees:0, AmtToBePaid:0})
    //     setQRData(null);
    //     setDisableInput(false)
    //     // Add any other reset logic here
    // };
   // Handle opening and closing of the dialog
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // Handle input change
    const handleMobileNoChange = (event) => {
        setMobileNo(event.target.value);
    };

    // Handle send link button click
    const handleSendLink = () => {
        // Logic to send the link goes here
        alert(`Link sent to ${mobileNo}`);
        setOpen(false); // Close the dialog after sending the link
    };
    const getURL = (amount, transferfee, rechargeId) => {
        let obj = {
            orderId: "_OrderID_",
            amount: amount,
            pgCharge: "0.00",
            pgAmount: amount,
            Status: 'PAYMENT_INITIATED',
            merchantTxnId: "_MTxnID_",
            pgTxnId: '',
            statusTime: getCurrentDateTime(),
            CompanyID: loginData?.intCompanyID,
            BranchID: loginData?.intBranchID,
            qrUTRNumber: '',
            RechargeStatus: '',
            transferfee: transferfee,
            PaymentProductTypeID: 4,
            BusinessVerticalID: 3,
            RechargeID: rechargeId,
        }
        return urls.QRPaymentDetailsInsertV2 + Object.keys(obj).map(key => `${key}=${encodeURIComponent(obj[key])}`).join('&')
    }
    const handleViewQR = async () => {
      const rechargeId = await handleSaveQR()
      setRemainingTime(false)
      let body = {
        agentid: 0,
        agentuserid: 0,
        amount: QRRechargeDeatils?.amountToBePaid,
        application: 'crs',
        branchid: loginData?.intBranchID,
        branchuserid: loginData?.intUserID,
        companyid: loginData?.intCompanyID,
        deviceid: '',
        devicetype: 'web',
        paymentmethod: 'qr',
        tag1: 'crs_cargo_branch_recharge',
        tag2: '',
        transferfee: QRRechargeDeatils?.processingFees,
        vertical: 'cargo',
        checksum: '',
      }
      const saltKey = 'salt-secret'
      const checksumValue = generateChecksum(body, saltKey)
      const payload = {
        ...body,
        checksum: checksumValue,
        extraInfo:{
            CrsCallback: getURL(QRRechargeDeatils?.amountToBePaid, QRRechargeDeatils?.processingFees, rechargeId)
        }
      }
      PostRequest('https://gpg.iamgds.com/api/v1/orders', payload).then(async (res) => {
        if (res?.isSuccess) {
          setQRData(res?.data)
          setDisableInput(true)
          handlePayment(res.data.orderId, rechargeId)
        } else {
          setQRData(null)
          setRemainingTime(false)
        }
      })
    }
    const handleStatus = (orderId, rechargeId) => {
        GetRequest(`https://gpg.iamgds.com/api/v1/orders/${orderId}/status`, {}).then((statusRes) => {
            if (statusRes?.isSuccess && rechargeId !== null && statusRes?.data?.status!=='') {
                // Handle the status response
                let obj = {
                    orderId: statusRes?.data?.orderId,//
                    amount: statusRes?.data?.amount,//
                    pgCharge: statusRes?.data?.pgCharge,//
                    pgAmount: statusRes?.data?.pgAmount,//
                    Status: statusRes?.data?.status,//confirm
                    merchantTxnId: statusRes?.data?.merchantTxnId,//
                    pgTxnId: statusRes?.data?.pgTxnId,//
                    statusTime: statusRes?.data?.statusTime,//
                    CompanyID: loginData?.intCompanyID,
                    BranchID: loginData?.intBranchID,
                    qrUTRNumber: statusRes?.data?.qrUTRNumber,//
                    RechargeStatus: '',//confirm
                    transferfee: statusRes?.data?.transferFee,//
                    PaymentProductTypeID: 4,
                    BusinessVerticalID: 3,
                    RechargeID: rechargeId//
                }
                dispatch(getDQRDetailsInsertUpdate(obj)).then((dispatchResult) => {
                    if (dispatchResult?.status==="Success") {
                        setShowQR(true)
                        if (statusRes.data.status === 'PAYMENT_SUCCESS') {
                            const confmBody = {
                                intCompanyID: loginData?.intCompanyID,
                                intBranchID: loginData?.intBranchID,
                                intRechargeID: rechargeId,
                                intUserIDRejected: 0,
                                intUserIDConfirmed: loginData?.intUserID
                            }
                            dispatch(BranchRechargeConfirm(confmBody)).then((branchrechargeRes)=>{
                                //check branchrechargeRes status is sucess
                                if(branchrechargeRes?.status==='Success'){
                                    GetRequestNoHeader(`https://gpg.iamgds.com/api/v1/orders/${orderId}/consumed?ConsumptionId=${rechargeId}`).then((consumeRes)=>{
                                        if(consumeRes?.isSuccess){
                                            handleCloseIntervals()
                                            setIsSuccess(true)
                                        }
                                     })
                                }
                            })
                        } else if (statusRes.data.status === 'PAYMENT_FAILURE' || statusRes.data.status === 'PAYMENT_INITIATE_FAILED') {
                            const rejectBody = {
                                intCompanyID: loginData?.intCompanyID,
                                intBranchID: loginData?.intBranchID,
                                intRechargeID: rechargeId,
                                intUserIDRejected: loginData?.intUserID
                            }
                            dispatch(BranchRechargeReject(rejectBody)).then(()=>{
                                handleCloseIntervals()
                                dispatch(updateAlertError({ show: true, msg: rh.rechargeFailedPleaseTryAgain || `Recharge failed!. Please Try again. `, nextId: '' }))
                                setQRRechargeDetails({ rechargeAmt: 0, processingFees: 0, AmtToBePaid: 0 })
                                setQRData(null);
                                setRemainingTime(false)
                                setDisableInput(false)
                            })
                        }
                    } else {
                        if(dispatchResult?.status==='Fail'){
                            dispatch(updateAlertError({ show: true, msg: dispatchResult?.ErrMessage, nextId: '' }))
                            handleCloseIntervals()
                        }
                    }
                }).catch((err)=>{
                    dispatch(updateAlertError({ show: true, msg: err, nextId: '' }))
                })
            }
        })
    }
    const handlePayment = async (orderId, rechargeId) => {
        setRemainingTime(true);
        await handleStatus(orderId, rechargeId);
    
        intervalIdRef.current = setInterval(async () => {
            await handleStatus(orderId, rechargeId);
        }, 10000);
    
        endTimeoutRef.current = setTimeout(() => {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
            dispatch(updateAlertError({ show: true, msg: rh.timeOutPleaseTryAgain || `Time Out!. Please Try Again`, nextId: '' }));
            handleCloseIntervals();
        }, 15 * 60 * 1000);
    };
    const handleCloseIntervals = () => {
        clearInterval(intervalIdRef.current);
        clearTimeout(endTimeoutRef.current);
        intervalIdRef.current = null;
        endTimeoutRef.current = null;
        setDisableInput(false);
        setRemainingTime(false);
    };
    useEffect(() => {
        return () => {
            handleCloseIntervals(); // Cleanup when component unmounts
        };
    }, []);
    return (
        <>
        <Box sx={{ padding: '10px', display: 'flex', justifyContent: 'space-between', backgroundColor: '#f2f9ff', border: '1px solid #2786ff', borderRadius: '10px' }}>
            <Box sx={{ width: '33%' }}>
                <Typography sx={{ fontWeight: 500, textTransform: 'uppercase', color: '#444', fontSize: '14px' }} variant="h5" display="block" >
                    {rh.scanAndPayWithAnyUpiApp || 'SCAN & Pay with any upi APP'}
                </Typography>
                <Box sx={{ paddingTop: '10px', display: 'flex', gap: '10px', alignContent: 'center' }}>
                    <img src={UPI} alt="upi" style={{
                        height: '20px',
                        width: '60px',
                    }} />
                    <img src={BHIM} alt="BHIM" style={{
                        height: '20px',
                        width: '80px',
                    }} />
                    <img src={googlePay} alt="googlePay" style={{
                        height: '20px',
                        width: '50px',
                    }} />
                    <img src={paytm} alt="paytm" style={{
                        height: '20px',
                        width: '60px',
                    }} />
                    <img src={phonepe} alt="phonepe" style={{
                        height: '25px',
                        width: '68px',
                    }} />

                </Box>
                <Typography sx={{ marginTop: '10px', fontWeight: 500, color: '#0086FF', fontSize: '12px' }} variant="h5" display="block" >
                    {rh.processingFeesNoteUpi || '*Please Note : Additional processing fees applicable on UPI Recharge.'}
                </Typography>
            </Box>
            <Box sx={{ width: '33%', textAlign: 'center' }}>
                {/* <div style={{ cursor: 'pointer' }} onClick={handleClose}>
                    <XIcons />
                </div> */}
                <Typography sx={{ fontWeight: 500, textTransform: 'uppercase', fontSize: '14px', color: '#444', textAlign: 'left', padding: '15px 10px' }} variant="h5"  >
                    {minimumAmount ? (rh.outstandingDetails || 'OUTSTANDING details') : (rh.rechargeDetails || 'RECHARGE details')}
                </Typography>
                <Item className={'input--wrapper btmSpaceNotRequired'} style={{ padding: '0px' }}>
                        <LineinputV2
                            label={rh.rechargeAmount || 'Recharge Amount'}
                            id={'recharge_Amount'}
                            filter={floatFilter}
                            value={QRRechargeDeatils?.rechargeAmt || 0}
                            onBlur={(e) => {
                                let val = Number(e.target.value) || 0
                                if(minimumAmount>0){
                                    val = Math.max(val,minimumAmount)
                                }
                                const amtToBePaid = (DQRDetails?.TransactionFeePer * (val)) / 100
                                setQRRechargeDetails((prev) => ({
                                    ...prev,
                                    rechargeAmt: val,
                                    processingFees: Number(amtToBePaid) || 0,
                                    amountToBePaid: RemoveQRTransFeeFromCustAmt ? val : (val + Number(amtToBePaid)) || 0
                                }))
                                if (val && val < MinQrAmount && !(minimumAmount > 0)) {
                                  setAlert({
                                    show: true,
                                    msg: (rh.rechargeForLessThanRsNotAllowed || 'Recharge For Less Then Rs. {amount} Not Allowed').replace('{amount}', MinQrAmount),
                                    nextId: 'recharge_Amount',
                                  })
                                }
                            }}
                            disabled={disableinput}
                        //  onKeyDown={(e) => {
                        //      navigation1(e, selPaymentMode?.RechargePaymentModeID === 7 ? 'generateOR' : 'bank_Name', 'select_Payment_Mode')
                        //  }}
                        />
                </Item>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                    <Typography sx={{ fontWeight: 500, textTransform: 'uppercase', fontSize: '14px', color: '#444' }} variant="h5"  >
                        {minimumAmount ? (rh.outstandingAmount || 'OUTSTANDING Amount') : (rh.rechargeAmountLabel || 'RECHARGE Amount')}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, textTransform: 'uppercase', fontSize: '14px', color: '#444' }} variant="h5"  >
                        {`Rs ${QRRechargeDeatils?.rechargeAmt||0}`}
                    </Typography>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                    <Typography sx={{ fontWeight: 500, textTransform: 'uppercase', fontSize: '14px', color: '#444' }} variant="h5"  >
                        {rh.processingFees || 'Processing Fees'}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, textTransform: 'uppercase', fontSize: '14px', color: '#444' }} variant="h5"  >
                    {`Rs ${RemoveQRTransFeeFromCustAmt ? 0: QRRechargeDeatils?.processingFees||0}`}
                    </Typography>
                </div>
                <Divider sx={{ marginTop: '16px', borderWidth: '2px', borderColor: '#0086FF' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                    <Typography sx={{ fontWeight: 500, textTransform: 'uppercase', fontSize: '14px', color: '#0086FF' }} variant="h5"  >
                        {rh.amountToBePaidUpper || 'Amount TO BE PAID'}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, textTransform: 'uppercase', fontSize: '14px', color: '#0086FF' }} variant="h5"  >
                    {`Rs ${QRRechargeDeatils?.amountToBePaid||0}`}
                    </Typography>
                </div>
            </Box>
            <Box sx={{ textAlign: 'center', width: '33%', position: 'relative' }}>
                <Typography
                    sx={{
                        fontWeight: 500,
                        textTransform: 'uppercase',
                        fontSize: '14px',
                        color: '#444',
                    }}
                    variant="h5"
                >
                    {rh.scanQrCode || 'Scan QR Code'}
                </Typography>
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: '14px',
                        color: '#444',
                    }}
                    variant="h5"
                >
                    {rh.paymentAmount || 'PAYMENT AMOUNT -'} <span style={{ color: '#0086FF' }}>{`Rs ${QRRechargeDeatils?.amountToBePaid||0}`}</span>
                </Typography>
               
                {QRData===null && <Item className="disabled-wrapper" style={{  display:'flex', justifyContent:'center',backgroundColor:'#f2f9ff'}} >
                    <Button variant="outlined" id='viewQR' sx={{ width: '100px', alignItems:'center' }} className="receiveitembtn" disabled={!QRRechargeDeatils?.rechargeAmt|| QRRechargeDeatils?.rechargeAmt < MinQrAmount}
                        onClick={() => {
                            handleViewQR()
                            // handleGenerateQRCode()
                            //  setShowQRScanner(true)
                            //  setShowPending(false)
                        }}
                    >
                        {rh.viewQr || 'VIEW QR'}
                    </Button>
                </Item>}
                {QRData && QRData?.qrUrl && showQR && (<div
                    style={{
                        display: 'flex', 
                        justifyContent: 'center', // Center horizontally
                        alignItems: 'center', // Center vertically
                    }}
                >
                    <div
                        id="qrCode"
                        className="QRimg"
                        style={{
                            display: 'flex', // Use flexbox
                            justifyContent: 'center', // Center horizontally
                            alignItems: 'center', // Center vertically
                            backgroundImage: `url(${QRData.qrUrl})`,
                            padding: '8px',
                            height: '168px',
                            width: '168px',
                            backgroundSize: 'cover', // Ensures the image covers the div
                            backgroundPosition: 'center', // Centers the image
                            border: '1px solid #ccc', // Optional: Add a border for better visibility
                        }}
                    />
                </div>

                )}
                {QRData && QRData?.qrUrl &&<Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: '12px',
                        color: '#444',
                    }}
                    variant="h5"
                >
                    {rh.poweredByIdfcBank || 'Powered By IDFC Bank'}
                </Typography>}

                {/* Share icon and label at the top right */}
                {/* <Box
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                    onClick={handleClickOpen}
                >
                    <ShareIcon sx={{ color: '#444', marginRight: '4px', fontSize: '20px' }} />
                    <Typography sx={{ fontSize: '14px', color: '#444' }}>Share</Typography>
                </Box> */}
                   {/* Timer Display */}
            {/* {isTimerActive && (
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: '14px',
                        color: '#444',
                        marginTop: '10px',
                    }}
                >
                    Time Remaining: {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}
                </Typography>
            )} */}
            {
                remainingTime?<QRTimer />:''
            }
            
            </Box>
            {/* Dialog Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                sx={{
                    '& .MuiDialog-paper': {
                        position: 'absolute',
                        top: '32%',
                        right: '5%',
                        margin: 0, // Remove margin to make it stick to the edge
                        padding: '0px !important'
                    }
                }}
            >
                <DialogTitle sx={{ position: 'absolute', top: 0, right: 0, padding: '8px' }}>
                    <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 0, right: 0 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ display: 'flex',padding:'0px' }}>
                    <Item className={'input--wrapper btmSpaceNotRequired'}>
                        <LineinputV2
                        text='number'
                            label={rh.mobileNumber || 'Mobile Number'}
                            id={'bank_Name'}
                        value={mobileNo}
                        maxLength={10}
                        onChange={(e) => {
                            const input = e.target.value;
                            // Allow only digits and limit to 10 characters
                            if (/^\d{0,10}$/.test(input)) {
                                setMobileNo(input);
                            }
                        }}

                        // disabled={selPaymentMode?.RechargePaymentModeID === 7}
                        // onKeyDown={(e) => {
                        //     navigation1(e, 'labelAmt', 'recharge_Amount')
                        // }}
                        />
                    </Item>
                    <Item className="disabled-wrapper" >
                        <Button variant="contained" id="RechargeBtn"   style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                        //disabled={mobileNo.length !== 10}
                        onClick={handleClose}
                        //  onKeyDown={(e) => {
                        //      navigation1(e, 'select_Payment_Mode', 'CANCEL')
                        //  }}
                        >
                            {rh.sendLink || 'Send Link'}
                        </Button>
                    </Item>
                </DialogContent>
            </Dialog>
        </Box>
            <SuccessAndErrorModal
                handleClose={() => {
                    setIsSuccess(false);
                    setShowQRScanner(false); updateModal();
                    setQRRechargeDetails({ rechargeAmt: 0, processingFees: 0, AmtToBePaid: 0 });
                    setRemainingTime(false); setQRData(null); setDisableInput(false);window.location.reload()
                }} open={isSuccess} title={(cs.rechargeRequestSubmittedSuccessfullyOfRs || 'Recharge Request Submitted\nSuccessfully of Rs {amount}').replace('{amount}', QRRechargeDeatils?.rechargeAmt)} modalStyle={modalStyle} />
   </>
        )
}

export default QRScanner